import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of, skipWhile} from 'rxjs';
import Pagination from '../../model/pagination';
import {environment} from '../../environments/environment';
import QueryEncoder from '../queryEncoder';
import {catchError, switchMap} from 'rxjs/operators';
import CooperationEventModel from '../../model/cooperationEvent.model';
import CooperationTaskModel from '../../model/cooperationTask.model';
import RevenueModel from '../../model/revenue.model';
import GenericCrudService from "../genericCrud.service";
import RevenueTotals from "../../model/revenueTotals.model";
import Crypto from "../../helper/crypto";
import RevenueHistoryModel from "../../model/revenueHistory.model";

@Injectable()
export default class RevenueService extends GenericCrudService<RevenueModel> {
  public constructor(protected http: HttpClient) {
    super(http);
  }

  getApiName() {
    return 'revenues';
  }

  public totals(query?: string, additionalInfo?: any, noCache?: boolean): Observable<RevenueTotals> {
    query = query || '';
    let q = {query};
    if(additionalInfo) {
      Object.assign(q, additionalInfo);
    }
    const key = 'cache-' + Crypto.SHA1(this.getApiName() + '?' + JSON.stringify(q));
    const subject = new BehaviorSubject<RevenueTotals>(null);
    this.cache.getCacheItem(key).then(async cacheResult => {
      if(cacheResult?.result) {
        let result = JSON.parse(cacheResult.result);
        for(let i = 0; i < result.results.length; i++) {
          let key = 'cache-' + Crypto.SHA1(this.getApiName() + '-' + (result.results[i] as any).id);
          let existing = await this.cache.getCacheItem(key);
          if(existing) {
            result.results[i] = JSON.parse(existing.result);
          }
        }
        result['cachedVersion'] = true;
        subject.next(result);
      }
    });
    this.http.get<RevenueTotals>(environment.apiUrl + '/revenues/totals' + '?' + QueryEncoder.encodeURI(q)).subscribe(result => {
      this.cache.removeCacheItem(key).then(_ => {
        this.cache.insertCacheItem({
          id: key,
          result: JSON.stringify(result)
        });
      });
      subject.next(result);
    });
    return subject.asObservable().pipe(skipWhile(e => {
      return e == null
    }));
  }

  public history(revenue: RevenueModel) {
    return this.http.get<RevenueHistoryModel[]>(environment.apiUrl + '/revenues/' + revenue.id + '/history');
  }
}
